$(document).ready(function () {
  /*
   * Evara performance cleanup
   * - Protegge le variabili globali opzionali.
   * - Unifica i controlli del free-product.
   * - Riduce listener e setTimeout duplicati.
   * - Mantiene cart, shipping protection e frequently bought.
   * - Rimuove i log di debug non necessari.
   */

  const freeProductThreshold =
    typeof amount_free_product !== "undefined"
      ? Number(amount_free_product)
      : 0;

  function formatPrice(originPrice, newPriceValue, isCount) {
    let priceValue = isCount
      ? newPriceValue.toString()
      : (newPriceValue / 100).toFixed(2).toString();

    if (originPrice.includes(",")) {
      priceValue = priceValue.replace(".", ",");
    }

    const originPriceNumber = originPrice.replace(/[^0-9.,]/g, "");

    return originPrice.replace(
      originPriceNumber.toString(),
      priceValue
    );
  }

  function updateCartPriceAndCount(cart) {
    const cartDrawerContainer = document.querySelector("cart-drawer");

    if (!cartDrawerContainer) return;

    const totalsElem = cartDrawerContainer.querySelector(
      ".gb-discounts-cart-values .totals__total"
    );

    const itemsCountElem = cartDrawerContainer.querySelector(
      ".gb-cart-total-item"
    );

    const totalPriceElem = cartDrawerContainer.querySelector(
      ".gb-discounts-cart-values .totals__total-value"
    );

    const comparePriceElem = cartDrawerContainer.querySelector(
      ".gb-discounts-cart-values .cart-item__old-price"
    );

    const itemCount = Number(cart.item_count) || 0;
    const totalPrice = Number(cart.total_price) || 0;

    const originPriceText =
      totalPriceElem?.innerText ?? "";

    const oldTotalPrice =
      originPriceText.replace(/[^0-9]/g, "");

    const oldComparePriceText =
      comparePriceElem?.innerText ?? "";

    if (totalPriceElem) {
      totalPriceElem.innerText = formatPrice(
        originPriceText,
        totalPrice
      );
    }

    if (itemsCountElem) {
      itemsCountElem.innerText = formatPrice(
        itemsCountElem.innerText,
        itemCount,
        true
      );
    }

    if (totalsElem) {
      totalsElem.innerText = formatPrice(
        totalsElem.innerText,
        itemCount,
        true
      );
    }

    if (comparePriceElem && oldComparePriceText) {
      const oldComparePrice =
        oldComparePriceText.replace(/[^0-9]/g, "");

      comparePriceElem.innerText = formatPrice(
        oldComparePriceText,
        parseInt(oldComparePrice, 10) +
          totalPrice -
          parseInt(oldTotalPrice || "0", 10)
      );
    }
  }

  function parseDisplayedPrice(value) {
    if (value == null) return 0;

    let cleaned = String(value)
      .replace(/\s/g, "")
      .replace(/[^\d.,-]/g, "");

    if (!cleaned) return 0;

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    if (lastComma !== -1 && lastDot !== -1) {
      if (lastComma > lastDot) {
        cleaned = cleaned
          .replace(/\./g, "")
          .replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (lastComma !== -1) {
      cleaned = cleaned
        .replace(/\./g, "")
        .replace(",", ".");
    } else {
      cleaned = cleaned.replace(/,/g, "");
    }

    const parsed = Number(cleaned);

    return Number.isFinite(parsed) ? parsed : 0;
  }

  /*
   * FREE PRODUCT
   */

  function checkFreeProductEligibility() {
    if (freeProductThreshold <= 0) return;

    const totalElement = document.querySelector(
      ".gb-totals-total-value"
    );

    if (!totalElement) return;

    const cartTotal = parseDisplayedPrice(
      totalElement.textContent
    );

    const freeProductInCart = document.querySelector(
      ".cart-item.gb-find-remove-product"
    );

    if (cartTotal >= freeProductThreshold) {
      if (!freeProductInCart) {
        $(".gb-free-product-tirgger").trigger("click");
      }
    } else {
      $(".gb-remove-product").trigger("click");
    }
  }

  let freeProductTimer = null;

  function scheduleFreeProductCheck(delay = 3000) {
    if (freeProductThreshold <= 0) return;

    clearTimeout(freeProductTimer);

    freeProductTimer = setTimeout(
      checkFreeProductEligibility,
      delay
    );
  }

  if (freeProductThreshold > 0) {
    scheduleFreeProductCheck(3000);

    $(document).on(
      "click",
      ".gb-sumbit-free",
      function () {
        scheduleFreeProductCheck(3000);
      }
    );

    $(document).on(
      "click change input",
      ".quantity__button, .quantity__input, .cart-remove-button",
      function () {
        scheduleFreeProductCheck(3000);
      }
    );
  }

  /*
   * SHIPPING PROTECTION
   */

  $(document).on(
    "click",
    ".gb-shipping-protection-button label.switch",
    async function (e) {
      if (e.target.tagName === "INPUT") return;

      const curElem = document.querySelector(
        ".gb-shipping-protection-button label.switch"
      );

      const curInputElem = document.querySelector(
        ".gb-shipping-protection-button label.switch input"
      );

      const spinAnim = document.querySelector(
        ".gb-shipping-protection-button .spin-animation"
      );

      const checkElem = document.querySelector(
        ".gb-shipping-protection-button .complete-check"
      );

      if (
        !curElem ||
        !curInputElem ||
        !spinAnim ||
        !checkElem
      ) {
        return;
      }

      if (
        curElem.classList.contains("unchecked") &&
        !curInputElem.checked
      ) {
        if (
          spinAnim.style.display === "block" ||
          curInputElem.checked
        ) {
          return;
        }

        const form = document.querySelector(
          "form.shipping-protection-form"
        );

        if (!form) return;

        const formData = new FormData(form);

        spinAnim.style.display = "block";

        try {
          const response = await fetch("/cart/add", {
            method: "POST",
            body: formData,
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (response.ok) {
            spinAnim.style.display = "none";
            checkElem.style.display = "block";

            const cartResponse =
              await fetch("/cart.js");

            if (cartResponse.ok) {
              updateCartPriceAndCount(
                await cartResponse.json()
              );
            }
          } else {
            spinAnim.style.display = "none";
          }
        } catch (err) {
          spinAnim.style.display = "none";
          console.error(
            "Shipping protection add failed:",
            err
          );
          return;
        }

        curElem.classList.remove("unchecked");
        curElem.classList.add("checked");

        curInputElem.checked = true;
      } else if (
        curElem.classList.contains("checked") &&
        curInputElem.checked
      ) {
        checkElem.style.display = "none";

        try {
          const cartResponse =
            await fetch("/cart.js");

          if (!cartResponse.ok) return;

          const cartData =
            await cartResponse.json();

          const protectItem =
            cartData.items.find(
              (_item) =>
                _item.id == shipping_product &&
                _item.discounts.length === 0
            );

          if (protectItem) {
            const response = await fetch(
              "/cart/update",
              {
                method: "POST",
                headers: {
                  "Content-Type":
                    "application/json",
                  Accept: "application/json",
                  "X-Requested-With":
                    "XMLHttpRequest",
                },
                body: JSON.stringify({
                  updates: {
                    [protectItem.key]: 0,
                  },
                }),
              }
            );

            if (response.ok) {
              updateCartPriceAndCount(
                await response.json()
              );
            }
          }
        } catch (err) {
          console.error(
            "Shipping protection removal failed:",
            err
          );
          return;
        }

        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");

        curInputElem.removeAttribute("checked");
        curInputElem.checked = false;
      }
    }
  );

  /*
   * FREQUENTLY BOUGHT VARIANT
   */

  $(document).on(
    "change",
    ".gb-change-variant_id",
    function () {
      const idChange = $(this)
        .find(":selected")
        .attr("data-variant-id");

      if (!idChange) {
        console.error(
          "No data-variant-id found on selected option"
        );
        return;
      }

      $(this)
        .closest(".gb-get-main-freq-pro")
        .find(".product-variant-id")
        .val(idChange);
    }
  );

  /*
   * FREQUENTLY BOUGHT VARIANTS IN CART DRAWER
   */

  document.addEventListener(
    "change",
    function (e) {
      if (
        !e.target.matches(
          ".cart-drawer .gbfrequently-bought-with-main-whole .select__select"
        )
      ) {
        return;
      }

      const parentBlock =
        e.target.closest(
          ".gb-get-main-freq-pro"
        );

      if (!parentBlock) return;

      const allValues = Array.from(
        parentBlock.querySelectorAll(
          ".select__select"
        )
      )
        .map((sel) => sel.value)
        .join(" / ");

      const variantSelect =
        parentBlock.querySelector(
          '[name="variants"]'
        );

      if (!variantSelect) return;

      const matchedOption =
        Array.from(
          variantSelect.options
        ).find((option) =>
          option.text.includes(allValues)
        );

      const idInput =
        parentBlock.querySelector(
          '[name="id"]'
        );

      if (!idInput) return;

      if (matchedOption) {
        idInput.value =
          matchedOption.value;
      }
    }
  );

  /*
   * CART ADD VALIDATION
   */

  document.addEventListener(
    "submit",
    function (e) {
      if (
        e.target.action &&
        e.target.action.includes("/cart/add")
      ) {
        const idInput =
          e.target.querySelector(
            '[name="id"]'
          );

        if (
          !idInput ||
          !idInput.value
        ) {
          e.preventDefault();
          return false;
        }
      }
    }
  );

  /*
   * PRODUCT QUANTITY
   */

  const productQuantitySelector =
    "#QuantitySelector-template--16566428696689__main-7356969582705";

  const productFormSelector =
    "#product-form-template--16566428696689__main";

  $(document).on(
    "change input",
    `${productQuantitySelector} .quantity__input`,
    function () {
      const quantityValue =
        $(this).val();

      const formElement =
        $(productFormSelector);

      if (!formElement.length) return;

      let quantityInput =
        formElement.find(
          'input[name="quantity"]'
        );

      if (!quantityInput.length) {
        quantityInput = $("<input>", {
          type: "hidden",
          name: "quantity",
        }).appendTo(formElement);
      }

      quantityInput.val(
        quantityValue
      );
    }
  );

  $(document).on(
    "submit",
    productFormSelector,
    function (e) {
      const idInput =
        $(this).find(
          'input[name="id"]'
        );

      let quantityInput =
        $(this).find(
          'input[name="quantity"]'
        );

      if (!idInput.val()) {
        e.preventDefault();
        return false;
      }

      if (!quantityInput.length) {
        quantityInput = $("<input>", {
          type: "hidden",
          name: "quantity",
          value: 1,
        }).appendTo(this);
      } else if (
        !quantityInput.val() ||
        Number(quantityInput.val()) < 1
      ) {
        quantityInput.val(1);
      }
    }
  );

  /*
   * CART QUANTITY
   */

  $(document).on(
    "click change input",
    ".cart-item .quantity__button, .cart-item .quantity__input",
    function () {
      const cartItem =
        $(this).closest(
          ".cart-item"
        );

      const quantityInput =
        $(this)
          .closest(".quantity-input")
          .find(".quantity__input");

      const variantId =
        quantityInput.data(
          "quantity-variant-id"
        );

      const form =
        cartItem.closest("form");

      if (!form.length) return;

      let idInput =
        form.find(
          'input[name="id"]'
        );

      if (
        !idInput.length &&
        variantId
      ) {
        idInput = $("<input>", {
          type: "hidden",
          name: "id",
          value: variantId,
        }).appendTo(form);
      } else if (
        idInput.length &&
        variantId
      ) {
        idInput.val(variantId);
      }
    }
  );

  /*
   * CART DRAWER CHECKOUT
   */

  $(document).on(
    "click",
    "#CartDrawer-Checkout",
    function (e) {
      const form =
        $("#CartDrawer-Form");

      if (!form.length) return;

      const cartItems =
        form.find(".cart-item");

      if (!cartItems.length) {
        e.preventDefault();
        return false;
      }
    }
  );

  /*
   * ENTER ON QUANTITY INPUT
   */

  $(document).on(
    "keydown",
    ".quantity__input",
    function (e) {
      if (
        e.key === "Enter" ||
        e.keyCode === 13
      ) {
        e.preventDefault();
        this.blur();
      }
    }
  );

  /*
   * FREQUENTLY BOUGHT PRODUCTS
   */

  $(document).on(
    "click",
    ".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-tirgger, .gb-product-shipping-protection-product-tirgger",
    function (e) {
      const $button = $(this);

      const parentBlock =
        $button.closest(
          ".gb-get-main-freq-pro, form"
        );

      if (!parentBlock.length) {
        e.preventDefault();
        return false;
      }

      let productId = null;

      let idInput =
        parentBlock.find(
          'input[name="id"]'
        );

      if (
        idInput.length &&
        idInput.val()
      ) {
        productId = idInput.val();
      } else if (
        parentBlock.find(
          ".gb-change-variant_id"
        ).length
      ) {
        const selectedOption =
          parentBlock.find(
            ".gb-change-variant_id option:selected"
          );

        if (selectedOption.length) {
          productId =
            selectedOption.data(
              "variant-id"
            );
        }
      } else if (
        parentBlock.find(
          ".product-variant-id"
        ).length
      ) {
        productId =
          parentBlock
            .find(
              ".product-variant-id"
            )
            .val();
      } else if (
        $button.data(
          "variant-id"
        )
      ) {
        productId =
          $button.data(
            "variant-id"
          );
      }

      if (!productId) {
        e.preventDefault();
        return false;
      }

      if (!idInput.length) {
        idInput = $("<input>", {
          type: "hidden",
          name: "id",
          value: productId,
        }).appendTo(parentBlock);
      } else {
        idInput.val(
          productId
        );
      }

      let quantityInput =
        parentBlock.find(
          'input[name="quantity"]'
        );

      if (!quantityInput.length) {
        quantityInput = $("<input>", {
          type: "hidden",
          name: "quantity",
          value: 1,
        }).appendTo(parentBlock);
      } else if (
        !quantityInput.val() ||
        Number(
          quantityInput.val()
        ) < 1
      ) {
        quantityInput.val(1);
      }
    }
  );
});